import { ICompany } from "@@types/ICompany";
import {
  CreateCompanyInput,
  SearchCompanyResponseOutput,
  SearchLegalCompanyInput,
  SearchPhysicalCompanyInput,
  UpdateCompanyInput,
} from "@_types/companies";
import { PaginationType, ResponsePaginationType } from "@_types/shared";
import { api } from "@services/apiClient";
import { AxiosPromise } from "axios";

export const createCompany = (data: CreateCompanyInput): AxiosPromise<{ uuid: string }> => {
  return api.post(`/companies`, data);
};

export const getCompanies = (params: PaginationType): AxiosPromise<ResponsePaginationType<ICompany>> => {
  return api.get(`/companies`, {
    params,
  });
};

export const searchLegalCompany = (data: SearchLegalCompanyInput): AxiosPromise<SearchCompanyResponseOutput> => {
  return api.get(`/companies/check/${data.document}`);
};

export const searchPhysicalCompany = (data: SearchPhysicalCompanyInput): AxiosPromise<SearchCompanyResponseOutput> => {
  return api.get(`/users/me`);
};

export const updateCompany = ({ uuid, ...data }: UpdateCompanyInput): AxiosPromise<{ uuid: string }> => {
  return api.put(`/companies/${uuid}`, data);
};
